export default "__VITE_ASSET__Drnx4b4k__"